<body>
  <div class="flex flex-col min-h-screen bg-gray-50">
    <app-header></app-header>

    <main class="flex-grow flex items-center justify-center py-12 px-4">
      <div class="max-w-3xl w-full bg-white p-6 rounded-2xl shadow-lg">
        <h1 class="text-[#134e4a] text-3xl font-bold mb-2 text-center">
          Member Onboarding Form
        </h1>
        <p class="mb-6 text-gray-600 text-center">
          Fill out this form to receive updates about upcoming programs and
          events.
        </p>

        <form [formGroup]="memberForm" (ngSubmit)="onSubmit()">
          <!-- Personal Information -->
          <section class="mb-6">
            <h2 class="text-lg font-semibold mb-4">Personal Information</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <mat-form-field appearance="outline">
                <mat-label>Full Name</mat-label>
                <input
                  matInput
                  formControlName="fullName"
                  (keydown)="onSignatureInput($event)"
                />
                <mat-error *ngIf="f.fullName.invalid && f.fullName.touched">
                  Full Name is required.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Email Address</mat-label>
                <input matInput type="email" formControlName="email" />
                <mat-error
                  *ngIf="f.email.hasError('required') && f.email.touched"
                >
                  Email is required.
                </mat-error>
                <mat-error *ngIf="f.email.hasError('email') && f.email.touched">
                  Enter a valid email address.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Phone Number</mat-label>
                <input
                  matInput
                  type="tel"
                  formControlName="phone"
                  (keydown)="onPhoneInput($event, f.phone.value)"
                />
                <mat-error
                  *ngIf="f.phone.hasError('required') && f.phone.touched"
                >
                  Phone number is required.
                </mat-error>
                <mat-error
                  *ngIf="f.phone.hasError('pattern') && f.phone.touched"
                >
                  Enter a valid phone number.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Age (Optional)</mat-label>
                <input
                  matInput
                  (keydown)="onNumberInput($event)"
                  formControlName="age"
                />
                <mat-error *ngIf="f.age.hasError('min') && f.age.touched">
                  Age must be greater than 0.
                </mat-error>
              </mat-form-field>
            </div>
          </section>

          <!-- Registration Type -->
          <section class="mb-6">
            <h2 class="text-lg font-semibold mb-4">Registration Type</h2>
            <mat-radio-group
              formControlName="registrationType"
              class="flex flex-col md:flex-row gap-4"
            >
              <mat-radio-button value="self"
                >Registering Yourself</mat-radio-button
              >
              <mat-radio-button value="children"
                >Registering Your Children</mat-radio-button
              >
            </mat-radio-group>
            <mat-error
              *ngIf="f.registrationType.invalid && f.registrationType.touched"
            >
              Please select a registration type.
            </mat-error>
          </section>

          <!-- Interests -->
          <section class="mb-6">
            <h2 class="text-lg font-semibold mb-4">Interests</h2>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Areas of Interest</mat-label>
              <mat-select formControlName="interests" multiple>
                <mat-option value="sports">Sports / Fitness</mat-option>
                <mat-option value="coding">Coding / STEM</mat-option>
                <mat-option value="art">Art / Creative</mat-option>
                <mat-option value="wellness">Wellness / Mindfulness</mat-option>
                <mat-option value="other">Other</mat-option>
              </mat-select>
              <mat-error *ngIf="f.interests.invalid && f.interests.touched">
                Please select at least one interest.
              </mat-error>
            </mat-form-field>
          </section>

          <!-- How did you hear about us -->
          <section class="mb-6">
            <h2 class="text-lg font-semibold mb-4">
              How did you hear about us?
            </h2>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Select an option</mat-label>
              <mat-select formControlName="source">
                <mat-option value="expo">Referral</mat-option>
                <mat-option value="social">Social Media</mat-option>
                <mat-option value="event">Event/Conference</mat-option>
                <mat-option value="search">Search Engine</mat-option>
                <mat-option value="ads">Online Ads</mat-option>
                <mat-option value="other">Other</mat-option>
              </mat-select>
              <mat-error *ngIf="f.source.invalid && f.source.touched">
                Please select one option.
              </mat-error>
            </mat-form-field>
          </section>

          <!-- Consent -->
          <section class="mb-6">
            <h2 class="text-lg font-semibold mb-4">Consent</h2>
            <div class="flex flex-col gap-2">
              <mat-checkbox formControlName="consentEmail">
                I agree to receive emails about upcoming programs.
              </mat-checkbox>

              <mat-error
                *ngIf="f.consentEmail.invalid && f.consentEmail.touched"
              >
                You must agree to receive emails.
              </mat-error>
            </div>
          </section>

          <!-- Submit -->
          <div class="text-center mt-6">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="memberForm.invalid"
              class="cursor-pointer"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </main>

    <app-footer></app-footer>
  </div>
</body>
